import React, { useCallback, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import { Huggg } from 'components';
import { Divider, PrimaryButton } from '@huggg/react-components';
import { Pin as PinForm } from 'components/forms';

import dictionary from 'config/dictionary';
import styles from './pin.module.scss';

import { fallbackError } from 'utilities/errorHandling';

const Pin = props => {
  const history = useHistory();

  const {
    clearRedeemError,
    huggg,
    isRedeeming,
    redeemError,
    redeemPin,
    onConfirm
  } = props;
  const formikMethods = useRef(null);

  const onSubmit = useCallback(
    (values, formikBag) => {
      if (onConfirm) {
        onConfirm();
      }
      formikMethods.current = formikBag;
      redeemPin(huggg.id, values.pin);
    },
    [huggg.id, redeemPin, onConfirm]
  );

  useEffect(() => {
    if (redeemError) {
      const errorMessage =
        redeemError.message === 'Invalid code'
          ? dictionary.invalidPin
          : fallbackError();

      formikMethods.current.setFieldError('pin', errorMessage);
      clearRedeemError();
    }
  }, [clearRedeemError, redeemError]);

  if (huggg && huggg.is_test) {
    history.push(`/test/${huggg.shortcode}/test-redeemed`);

    return '';
  }

  return (
    <div className="container">
      <Huggg huggg={huggg} />
      <Divider />

      {huggg && huggg.is_test && (
        <>
          <p className={styles.testHugggText}>
            This is a test huggg, please just enter 0000 as the pin.
          </p>
          <br />
        </>
      )}
      <PinForm
        className={styles.form}
        onSubmit={onSubmit}
        focusOnMount={true}
        data-test-id="redeem-pin-form"
        button={
          <PrimaryButton
            data-test-id="redeem-pin-submit"
            disabled={isRedeeming}
            label="CONFIRM"
            style={{ marginTop: '32px', marginBottom: '8px' }}
          />
        }
      />
    </div>
  );
};

Pin.propTypes = {
  clearRedeemError: PropTypes.func.isRequired,
  huggg: PropTypes.object.isRequired,
  isRedeeming: PropTypes.PropTypes.bool.isRequired,
  redeemPin: PropTypes.func.isRequired,
  redeemError: PropTypes.object,
  onConfirm: PropTypes.func
};

export default Pin;
